/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MarketShoppingBagIcon16Solid = forwardRef('MarketShoppingBagIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.058 3.177A2.5 2.5 0 0 1 4.537 1h6.926a2.5 2.5 0 0 1 2.48 2.177l1.043 8A2.5 2.5 0 0 1 12.506 14H3.494a2.5 2.5 0 0 1-2.479-2.823l1.044-8Zm3.778 1.086a.75.75 0 1 0-1.422.474C4.919 6.251 6.324 7.361 8 7.361s3.081-1.11 3.586-2.624a.75.75 0 0 0-1.422-.474C9.849 5.205 8.989 5.86 8 5.86c-.989 0-1.849-.656-2.164-1.598Z" })));
});
